module.exports = __webpack_public_path__ + "img/pago.809aa3fc.png";